import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  Bar,
  XAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

const calculateValue = value => {
  let isValue = Object.entries(value);
  let arr = [];
  if (isValue.length === 1) {
    if(isValue[0]){
      arr.push(isValue[0][1].B3,isValue[0][1].Mohalla,isValue[0][1].Wholesale)
    }
    // isValue.forEach((item, ind) => {
    //   let secondArr = [];
    //   // secondArr.push(Object.entries(item[1])[0][1]);
    //   // arr.push(secondArr[0].B3, secondArr[0].Mohalla, secondArr[0].Wholesale);
    //   arr.push(item[1].B3,item[1].Mohalla,item[1].Wholesale)
    // });
  }
  else{
    if(isValue[0] && isValue[1]){
      arr.push(isValue[0][1].B3,isValue[1][1].B3,
        isValue[0][1].Mohalla,isValue[1][1].Mohalla,
        isValue[0][1].Wholesale,isValue[1][1].Wholesale)
    }
  }
  return arr;
};

const CustomizedLabel = props => {
  const { x, y, value } = props;
  if (value) {
    return (
      <g>
        <text
          x={x + 30}
          y={y}
          dy={15}
          fill={"white"}
          fontSize={12}
          textAnchor="middle"
          position="center"
        >
          {value?.toFixed(1)}%
        </text>
      </g>
    );
  } else {
    return "";
  }
};

const CustomizedLabel2 = props => {
  const { x, y, value } = props;
  if (value) {
    return (
      <g>
        <text
          x={x + 20}
          y={y}
          dy={-4}
          fill={"black"}
          fontSize={12}
          position="top"
          fontWeight={600}
        >
          {value?.toFixed(1)}%
        </text>
      </g>
    );
  } else {
    return "";
  }
};

const CustomizedLabel3 = props => {
  const { x, y, value } = props;
  if (value) {
    return (
      <g>
        <rect
          x={value > 100 ? x - 25 : x - 30}
          y={y - 23}
          width="50px"
          height="20px"
          fill="#4d4f5c"
        />
        <text
          x={x - 20}
          y={y}
          dy={-10}
          fill={"white"}
          fontSize={12}
          position="top"
          fontWeight={600}
        >
          {value?.toFixed(1)}%
        </text>
      </g>
    );
  } else {
    return "";
  }
};


const renderLegend = (props) => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center', position: 'absolute', width: '100%' }}>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#8a614b', marginRight: '8px' }}></span>
        <span>ELDP</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#0353a4', marginRight: '8px' }}></span>
        <span>SBB</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#63993d', marginRight: '8px' }}></span>
        <span>TPR</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#ec7c30', marginRight: '8px' }}></span>
        <span>GIFTS</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#62aaa3', marginRight: '8px' }}></span>
        <span>CHANNEL INCENTIVE</span>
      </span>
    </div>

  );
}

function ChannelUtilizationBarChart(props) {
  let graphData = calculateValue(props.data);     // value conversion for graph mapping
  return (
    <>
      <ResponsiveContainer width={"100%"} height={"100%"}>
        <ComposedChart
          width={150}
          height={180}
          data={graphData}
          margin={{ top: 20, right: 40, bottom: 20, left: 50 }}
        >
          <XAxis
            dataKey="MapChannel"
            axisLine={{ stroke: "#e6e6e7" }}
            style={{ fontSize: "11px" }}
            tickLine={false}
          />
          <Legend content={renderLegend} />
          <Bar dataKey="EDLP" stackId="a" barSize={60} fill="#8a614b" 
            isAnimationActive={false}>
            <LabelList
              dataKey="EDLP"
              content={CustomizedLabel} // Label inside of bar chart
              fontSize={12}
              position="center"
              fill={"white"}
            />
          </Bar>
          <Bar dataKey="SBB" stackId="a" barSize={60} fill="#0353a4"
            isAnimationActive={false}>
            <LabelList
              dataKey="SBB"
              content={CustomizedLabel} // Label inside of bar chart
              fontSize={12}
              position="center"
              fill={"white"}
            />
          </Bar>
          <Bar dataKey="TPR" stackId="a" barSize={60} fill="#63993d" 
            isAnimationActive={false}>
            <LabelList
              dataKey="TPR"
              content={CustomizedLabel} // Label inside of bar chart
              fontSize={12}
              position="center"
              fill={"white"}
              isAnimationActive={false}
            />
          </Bar>
          <Bar dataKey="GIFTS" stackId="a" barSize={60} fill="#ec7c30" 
            isAnimationActive={false}>
            <LabelList
              dataKey="GIFTS"
              content={CustomizedLabel} // Label inside of bar chart
              fontSize={12}
              position="center"
              fill={"white"}
            />
          </Bar>
          <Bar
            dataKey="CHANNELINC"
            stackId="a"
            barSize={60}
            fill="#62aaa3"
            isAnimationActive={false}
          >
            <LabelList
              dataKey="TotalUtilization"
              content={CustomizedLabel2} // Label on top of bar chart
              fontSize={12}
              position="top"
              fill={"black"}
            />
            <LabelList
              dataKey="CHANNELINC"
              content={CustomizedLabel} // Label inside of bar chart
              fontSize={12}
              position="center"
              fill={"white"}
            />
          </Bar>
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
}

function ChannelUtilizationLineChart(props) {
  let graphData = calculateValue(props.data);     // value conversion for graph mapping
  return (
    <>
      <ResponsiveContainer width={"100%"} height={"100%"}>
        <ComposedChart
          width={150}
          height={180}
          data={graphData}
          margin={{ top: 20, right: 40, bottom: 20, left: 50 }}
        >
          <XAxis
            dataKey="YearNo"
            axisLine={false}
            tickLine={false}
            fontSize={12}
          />
          <Tooltip content={e => renderTooltip(e)} />
          <Line
            type="linear"
            dataKey="Goly"
            stroke="#4d4f5c"
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          >
            <LabelList dataKey="Goly" 
            content={CustomizedLabel3}     //Label on line chart
            />
          </Line>
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
}

const renderTooltip = e => {
  return (
    <div className="major-channel-utilization-tooltip">
      <div className="major-channel-utilization-tooltip-heading">
        <span>{e?.payload?.length ? e?.payload[0]?.payload?.MapChannel : ''}</span>
        <span>{e?.payload?.length ? e?.payload[0]?.payload?.YearNo : ''}</span>
      </div>
      <div className="major-channel-utilization-tooltip-data">
        <span style={{ color: "#62aaa3" }}>
          ChannelIncentive :{" "}
          {e?.payload?.length ? e?.payload[0]?.payload?.CHANNELINC?.toFixed(1) : ''}%
        </span>
        <span style={{ color: "#ec7c30" }}>
          GIFTS : {e?.payload?.length ? e?.payload[0]?.payload?.GIFTS?.toFixed(1) : ''}%
        </span>
        <span style={{ color: "#63993d" }}>
          TPR : {e?.payload?.length ? e?.payload[0]?.payload?.TPR?.toFixed(1) : ''}%
        </span>
        <span style={{ color: "#0353a4" }}>
          SBB : {e?.payload?.length ? e?.payload[0]?.payload?.SBB?.toFixed(1) : ''}%
        </span>
        <span style={{ color: "#8a614b" }}>
          EDLP : {e?.payload?.length ? e?.payload[0]?.payload?.EDLP?.toFixed(1) : ''}%
        </span>
        <span>Goly : {e?.payload?.length ? e?.payload[0]?.payload?.Goly?.toFixed(1) : ''}%</span>
        <span>
          TotalUtilization :{" "}
          {e?.payload?.length ? e?.payload[0]?.payload?.TotalUtilization?.toFixed(1) : ''}%
        </span>
      </div>
    </div>
  );
};

function ChannelUtilizationChart(props) {
  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <div style={{ position: "absolute", width: "100%", height: "100%" }}>
        {ChannelUtilizationBarChart(props)}
      </div>
      <div
        style={{
          position: "absolute",
          zIndex: 1,
          width: "100%",
          height: "100%",
          top: "12px"
        }}
      >
        {ChannelUtilizationLineChart(props)}
      </div>
    </div>
  );
}

export default ChannelUtilizationChart;
